/* eslint-disable react/prop-types */
// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { _api } from "../../api/Api";
import { customStyleSm } from "../../utils/common";
import { useSelector } from "react-redux";

const MainModal = (props) => {
  const { register, handleSubmit, setValue, reset, clearErrors, control, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const drpMake = useSelector((state) => state.make);
  const drpModel = useSelector((state) => state.model);
  const drpVariant = useSelector((state) => state.variants);
  const drpCity = useSelector((state) => state.cities);
  const allVehcilesFlat = useSelector((state) => state.allVehcilesFlat);
  const customDropdowns = { drpMake, drpModel, drpVariant, drpCity, allVehcilesFlat };
  const selectFields = props.config?.fields?.filter((field) => field.type === "select") || [];
  useEffect(() => {
    if (props && props.selectedData && Object.keys(props.selectedData).length > 0) {
      props?.config?.fields?.forEach((value) => {
        setValue(value.fieldName, props.selectedData[value.fieldName]);
      });
    }
  }, [props.selectedData])

  useEffect(() => {
    selectFields?.forEach(async (selectField) => {
      if (selectField?.drpData?.url) {
        try {
          await _api("GET", selectField.drpData.url, null, function (ret) {
            if (ret && ret.data?.length > 0) {
              const options = ret.data.map(item => ({
                value: item[selectField.drpData.value],
                label: item[selectField.drpData.displayName],
              }));
              selectField.drpData["options"] = options;
            }
          });
        } catch (error) {
          console.warn("Something went wrong while fetching dropdown API [MainModal]", error.message);
        }
      }
      else if (selectField?.drpData?.type === "Custom") {

        const keyName = selectField?.drpData?.key;

        if (customDropdowns[keyName]) {
          selectField.drpData.options = customDropdowns[keyName];
        } else {
          console.warn("Custom dropdown key not found: ", keyName);
          selectField.drpData.options = []
        }
      }
      else if (selectField?.drpData?.data) {
        const drp = selectField.drpData;
        const options = drp.data.map(item => ({
          value: item[drp.value],       // item["xid"] → 1, 2
          label: item[drp.displayName]  // item["xlabel"] → "Udhari", "Hath k Hath"
        }));
        selectField.drpData["options"] = options;
      }
    });
  }, [selectFields]);


  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await props.modalsave(data);
      clearForm();
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    reset();
    clearErrors();
    props.modalshow({}, false);
  };

  const handleClose = () => {
    props.modalshow({}, false);
    clearForm();
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={handleClose}
        size={props.size}
        centered
        // scrollable
        backdrop="static"
        // keyboard={false}
        {...props}>
        <Modal.Header
          closeButton
          // 'close-white' is a Bootstrap class that turns the 'X' icon white
          closeVariant="white"
          className="border-bottom-0 px-4"
          style={{
            padding: '10px',
            backgroundColor: '#38BABA', // Deep dark slate
            borderTopLeftRadius: '8px', // Matches the modal rounding
            borderTopRightRadius: '8px',
          }}
        >
          <Modal.Title className="d-flex align-items-center text-light fw-bold">
            {/* Dynamic Icon based on Page Name or a General Icon */}
            <span style={{ letterSpacing: '0.5px', fontSize: "14px" }}>
              {props.page}
            </span>
          </Modal.Title>
        </Modal.Header>
        {props.children ? (
          <>
            <Modal.Body style={{ backgroundColor: 'rgb(255, 255, 255)', position: "relative", }}>
              {props.children}
            </Modal.Body>
            {props.showSubmit !== false && (
              <Modal.Footer className="modal-footer d-flex justify-content-end pt-0" style={{
                backgroundColor: 'rgb(255, 255, 255)', // Deep dark slate
              }}>
                <button type="button" className="btn btn-submit" form={props?.formId || ""} onClick={() => props.modalsave()} disabled={props.loading}>
                  {props.loading ? (<>  <i className="fas fa-spinner fa-spin me-2" />  Submitting... </>
                  ) : ("Submit")}
                </button>
              </Modal.Footer>
            )}
          </>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Body style={{ backgroundColor: 'rgb(255, 255, 255)' }}>
              <div className="row">
                {props.config?.fields?.map((field, key) => {
                  if (!field.isVisible || field.type === "Seperation") return null;
                  const isRequired = field.required
                  // const isRequired = field.required ? field.requiredObj.required : false;
                  const label = (
                    <label className="form-label">
                      {field.required && '*'}{field.displayName}
                    </label>
                  );

                  if (field.type === "text" || field.type === "number" || field.type === "password" || field.type === "email" || field.type === "date") {
                    return (
                      <div
                        key={key}
                        className={field.clsName}
                      //style={{ display: field.type === "password" && Object.keys(props.selectedData || {}).length > 0 ? "none" : "block" }}
                      >
                        <div className="form-group mb-3 input-group-md">
                          {label}
                          <input
                            type={field.type}
                            className="form-control"
                            placeholder={field.placeHolder}
                            autoComplete="off"
                            min={field.type === "number" ? 0 : undefined}
                            {...register(field.fieldName, {
                              required: isRequired ? `${field.displayName} is required` : false,
                              valueAsNumber: field.type === "number",  // only converts number input
                              validate: field.type === "number" ? (v) => v >= 0 || "Negative value not allowed" : undefined,
                            })}
                          />
                          {errors[field.fieldName] && (
                            <span className="badge bg-soft-danger">
                              {errors[field.fieldName]?.message || "This field is required"}
                            </span>
                          )}
                        </div>

                      </div>
                    );
                  }

                  if (field.type === "textarea") {
                    return (
                      <div key={key} className={field.clsName}>
                        <div className="form-group mb-3 input-group-md">
                          {label}
                          <textarea
                            className="form-control"
                            rows={field.rows || 3}
                            placeholder={field.placeHolder}
                            autoComplete="off"
                            {...register(field.fieldName, {
                              required: isRequired ? `${field.displayName} is required` : false,
                            })}
                          />
                          {errors[field.fieldName] && (
                            <span className="badge bg-soft-danger">
                              {errors[field.fieldName]?.message || "This field is required"}
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  }

                  if (field.type === "select") {
                    return (
                      <div key={key} className={field.clsName}>
                        <div className="form-group mb-3 input-group-md">
                          {label}
                          <Controller
                            name={field.fieldName}
                            control={control}
                            rules={{ required: isRequired }}
                            render={({ field: controllerField }) => (
                              <Select
                                {...controllerField}
                                options={field.drpData?.options || []}
                                value={
                                  field.isMultiSelect
                                    ? field.drpData?.options?.filter(option =>
                                      (controllerField.value || []).includes(option.value)
                                    )
                                    : field.drpData?.options?.find(option =>
                                      option.value === controllerField.value
                                    ) || null
                                }
                                onChange={(selected) => {
                                  if (field.isMultiSelect) {
                                    controllerField.onChange(selected ? selected.map(item => item.value) : []);
                                  } else {
                                    controllerField.onChange(selected?.value || null);
                                  }
                                }}
                                placeholder={field.placeHolder}
                                isClearable
                                isMulti={field?.isMultiSelect || false}
                                className={`select2 ${errors[field.fieldName] ? "is-invalid" : ""}`}
                                styles={customStyleSm}
                              />
                            )}
                          />
                          {errors[field.fieldName] && (
                            <span className="badge bg-soft-danger">
                              {errors[field.fieldName]?.message || `${field.displayName} is required`}
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  }

                  return null;
                })}
              </div>
            </Modal.Body>

            <Modal.Footer className="modal-footer d-flex justify-content-end pt-0" style={{
              backgroundColor: 'rgb(228, 230, 231)', // Deep dark slate
            }}>
              <button type="submit" className="btn btn-submit" disabled={loading}>
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin me-2" />
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </Modal.Footer>
          </form>
        )}
      </Modal>
    </>
  );
};

export default MainModal;
